// alloyConfigService.js

import workspace from "./workspace";

export const getAlloyConfigs = async (osType) => {
  try {
    const response = await workspace.get(`/alloy-config/${osType}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching alloy configs:", error);
    throw error;
  }
};

export const getAlloyConfigById = async (id, osType) => {
  try {
    const response = await workspace.get(`/alloy-config/${osType}/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching alloy config with ID ${id}:`, error);
    throw error;
  }
};

export const createAlloyConfig = async (configData, osType) => {
  try {
    const response = await workspace.post(`/alloy-config/${osType}/`, configData);
    return response.data;
  } catch (error) {
    console.error("Error creating alloy config:", error);
    throw error;
  }
};

export const updateAlloyConfig = async (id, configData, osType) => {
  try {
    const response = await workspace.put(`/alloy-config/${osType}/${id}/`, configData);
    return response.data;
  } catch (error) {
    console.error(`Error updating alloy config with ID ${id}:`, error);
    throw error;
  }
};

export const deleteAlloyConfig = async (id, osType) => {
  try {
    const response = await workspace.delete(`/alloy-config/${osType}/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting alloy config with ID ${id}:`, error);
    throw error;
  }
};
